<template>
  <div class="ui-form-item" @click="handleClick">
    <div class="icon-wrapper">
      <slot name="icon">
        <i class="icon" :class="`icon_${icon}`"></i>
      </slot>
    </div>
    <div class="label">
      {{ label }}
    </div>
    <div class="right-wrapper">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "uiFormItem",
  props: {
    value: {
      type: [String],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClick() {
      this.$emit("click")
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-form-item {
  width: 100%;
  height: 1.02rem;
  border-bottom: 1px solid #e3e3e3;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-right: 0.4rem;
  .icon-wrapper {
    margin-right: 0.12rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    .icon {
      width: 0.28rem;
      height: 0.28rem;
      &.icon_header {
        background: url("./images/icon_head.png") no-repeat center;
        background-size: 100%;
      }
      &.icon_name {
        background: url("./images/icon_name.png") no-repeat center;
        background-size: 100%;
      }
      &.icon_location {
        background: url("./images/icon_location.png") no-repeat center;
        background-size: 100%;
      }
      &.icon_school {
        background: url("./images/icon_school.png") no-repeat center;
        background-size: 100%;
      }
      &.icon_grade {
        background: url("./images/icon_grade.png") no-repeat center;
        background-size: 100%;
      }
      &.icon_teacher {
        background: url("./images/icon_teacher.png") no-repeat center;
        background-size: 100%;
      }
      &.icon_phone {
        background: url("./images/icon_phone.png") no-repeat center;
        background-size: 100%;
      }
      &.icon_unit {
        background: url("./images/icon_unit.png") no-repeat center;
        background-size: 100%;
      }
    }
  }
  .label {
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    color: #666666;
    flex: none;
    margin-right: 0.4rem;
  }
  .right-wrapper {
    flex: 1;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    color: #333333;
    overflow: hidden;
  }
}
</style>
